module.exports = __webpack_public_path__ + "img/bookmarks.a5e50654.svg";